import { z } from 'zod'

import { entitySchema, nanoidSchema } from '@/utility'

export enum ConfigVersion {
  V1 = '1.0.0',
  V2 = '2.0.0',
}

export const publishRecordSchema = entitySchema
  .extend({
    projectUid: nanoidSchema,
    status: z.union([
      z.literal('pending'),
      z.literal('building'),
      z.literal('deployed'),
      z.literal('inactive'),
      z.literal('error'),
      z.literal('deleted'),
    ]),
    deployedAt: z.number().nullable().default(null),
    message: z.string().default(''),
    domain: z.string().default(''),
    preview: z.boolean().optional().default(false),
    commitSha: z.string().nullable().default(null),
    version: z.enum(ConfigVersion).default(ConfigVersion.V1),
    isWysiwyg: z.boolean().default(false),
    subpath: z.string().nullable().default(null),
    configPath: z.string().optional().default('scalar.config.json'),
    registryApis: z
      .object({
        uid: nanoidSchema,
        version: z.string(),
      })
      .array()
      .optional()
      .default([]),
  })
  .meta({ id: 'publish-record' })

export type PublishRecord = z.infer<typeof publishRecordSchema>
